import { getAllTicket } from "../api/ticketApi";

export const checkForNewBackendTickets = async (workspace_id) => {
  try {
    const data = await getAllTicket(workspace_id);

    // All tickets assigned by backend
    const assignedTickets = data.results.filter(ticket => ticket.assign_to !== null);

    // Store all assigned ticket IDs (new and old)
    const storedIds = JSON.parse(localStorage.getItem("backendTicketIdsAtLogin")) || [];
    //console.log('sssss',storedIds);
    const assignedIds = assignedTickets.map(ticket => ticket.id);
    localStorage.setItem("backendTicketIdsAtLogin", JSON.stringify(assignedIds));
    //.log('aaaaa',assignedIds);

    // Filter tickets that are both stored and still "Open"
    const openStoredTickets = assignedTickets.filter(ticket =>
      storedIds.includes(ticket.id) && ticket.status_display === "Open"
    );
    //console.log('openstoredtickets',openStoredTickets);
   
    const newOpenTickets = assignedTickets.filter(ticket =>
      !storedIds.includes(ticket.id) && ticket.status_display === "Open"
    );
    //console.log('newwww open tickets',newOpenTickets);
    
    const ticketsToShow = [...openStoredTickets, ...newOpenTickets];
     const filteredTickets = ticketsToShow.filter(ticket => ticket.user_reply === true);
      // console.log('Tickets to show user_reply  true', filteredTickets);
       return filteredTickets;


  //  console.log('ticketshow',ticketsToShow);
    // return ticketsToShow;

  } catch (error) {
    console.error("Error checking backend tickets:", error);
    return [];
  }
};



// export const checkForNewBackendTickets = async (workspace_id) => {
//   try {
//     const data = await getAllTicket(workspace_id);
//      console.log('ddddd',data);
//     // Tickets assigned by backend 
//     const backendTickets = data.results.filter(ticket => ticket.assign_to !== null && ticket.status_display === "Open");
//     console.log(backendTickets);
//     const backendIds = backendTickets.map(ticket => ticket.id);
//     console.log(backendIds);
//     // console.log(backendTickets);

//     const storedIds = JSON.parse(localStorage.getItem("backendTicketIdsAtLogin")) || [];
//     console.log('stored ids',storedIds);

//     const newTickets = backendTickets.filter(ticket =>
//       !storedIds.includes(ticket.id)
//     );
//     console.log('newTickets',newTickets);
//     if (newTickets.length > 0) {

//       const updatedIds = [...storedIds, ...newTickets.map(ticket => ticket.id)];
//       console.log('uuuuu',updatedIds)
//       localStorage.setItem("backendTicketIdsAtLogin", JSON.stringify(updatedIds));
//       return newTickets;
//       // latest = newTickets[0];
//       // console.log('latest', latest);
//       // Store it to localStorage to avoid duplicate popups
//       // localStorage.setItem(
//       //   "backendTicketIdsAtLogin",
//       //   JSON.stringify([...storedIds, latest.id])
//       // );

//          // return the new ticket
//     }

//      return [];
//   } catch (error) {
//     console.error("Error checking backend tickets:", error);
//      return [];
//   }
// };
